const USER_ROLES = {
  SUPER_ADMIN: "SUPER_ADMIN",
  AGENCY_ADMIN: "AGENCY_ADMIN",
  AGENCY_USER: "AGENCY_USER",
  TRAVELLER: "TRAVELLER"
};

export default USER_ROLES;
